<template>
  <transition name='fade'>
    <div
      class="modal headimg_box"
      v-if='visible'
    >
      <div
        class="headimg"
        v-loading='cropperImgLoading'
        element-loading-text="加载中，请稍后"
      >
        <div class="title msp_icon_close">
          <span
            class="title_name"
            v-if="cropType === 'headImgcrop'"
          >头图裁剪</span>
          <span
            class="title_name"
            v-if="cropType === 'atlImgCrop'"
          >图片裁剪</span>
          <span
            class="iconfont el-icon-close"
            @click.stop='closeBox()'
          ></span>
        </div>
        <div class="watermark">
          <div class="watermark_left">
            <div class="watermark_title">裁剪比列</div>
            <div
              class="each_cropper_button"
              :class="[item.value === currentSize ? 'each_cropper_button_active':'']"
              @click.stop='setCropperSize(item)'
              v-for="item in cropSizeList"
            >
              <el-button>{{item.name}}</el-button>
            </div>

          </div>
          <div class="watermark_right">
            <div class="content_title">
              <span>图片</span>
            </div>
            <div class="cropper_container">
              <img
                :src="followOrignUrl"
                alt=""
                id='image'
              >
            </div>

          </div>

        </div>

        <div class="headimg_buttom">
          <el-button
            type="primary"
            @click.native='getCropperImg()'
          >确定</el-button>
        </div>

      </div>
    </div>
  </transition>
</template>

<script>

import * as api from '../../../api'
import axios from 'axios'
export default {
  name: 'cropper',
  data () {
    return {
      visible: false,
      cropperImgLoading: false,
      currentSize: 16 / 10,
      followOrignUrl: '',
      headimgOrignUrl: '',
      cropType: '',
      cropSizeList: [
        { name: '自定义', value: NaN },
        { name: '2:1', value: 2 / 1 },
        { name: '4:3', value: 4 / 3 },
        { name: '16:9', value: 16 / 9 },
        { name: '16:10', value: 16 / 10 }
      ]
    }
  },
  mounted () {
    this.$root.eventHub.$on('setCropperModel', (data, type) => {
      this.visible = true
      this.headimgOrignUrl = data
      this.cropType = type
      this.getFollowOrignUrl(data)
    })

  },
  destroyed () {
    this.$root.eventHub.$off('setCropperModel')
  },
  components: {

  },
  computed: {

  },
  methods: {
    closeBox () {
      this.visible = false
    },
    cropperJs () {
      var $image = $('#image');
      $image.cropper({
        aspectRatio: 16 / 10,
        autoCrop: true,
        crop: function (event) {

        },
        ready: function () {
          console.log('初始化已完成')
        }
      });
      $image.cropper('getCroppedCanvas', {
        width: 160,
        height: 90,
        fillColor: '#fff',
        imageSmoothingEnabled: false,
        imageSmoothingQuality: 'high',
      });

      // Get the Cropper.js instance after initialized
      var cropper = $image.data('cropper')
      console.log(cropper)
    },

    //获取跨域图片
    getFollowOrignUrl (data) {
      var url = '//oss-auth.dacube.cn/picture/get_url'
      this.cropperImgLoading = true
      var option = {
        url: data
      }
      api._post(url, option).then((res) => {
        if (res.code == 200) {
          this.followOrignUrl = res.data
          this.$nextTick(() => {
            this.cropperJs()
          })

        } else {
          this.followOrignUrl = ''
        }
        this.cropperImgLoading = false
      }).catch((error) => {
        console.log(error)
        this.followOrignUrl = ''
        this.cropperImgLoading = false
      })
    },

    setCropperSize (item) {
      $('#image').cropper('setAspectRatio', item.value)
      this.currentSize = item.value
      $('.each_cropper_button').removeClass('each_cropper_button_active')
      if (item.name === '自定义') {
        $('.each_cropper_button').eq(0).addClass('each_cropper_button_active')
      }

    },
    getCropperImg () {
      var cas = $('#image').cropper('getCroppedCanvas');
      var self = this
      cas.toBlob(function (e) {
        var timestamp = Date.parse(new Date());
        e.name = timestamp + ".png";
        self.getOssUrl(e)
      })

    },
    getOssUrl (image) {
      var url = 'https://oss-auth.dacube.cn/oss-auth/auth?bucket=intellieditor&app_key=HLsMVqn73KkhJx55stEnEho8VWfvDI4LVY5Z2DD7xA2Xf5hb4zYN3zXkEcuzt712&expire=&path=intellieditor'
      api._get(url, '').then((response) => {
        if (response.code == 200) {
          let form_data = new FormData()
          var imageUri = 'intellieditor/' + image.name
          form_data.append('OSSAccessKeyId', response.data.accessKeyId)
          form_data.append('policy', response.data.policy)
          form_data.append('Signature', response.data.signature)
          form_data.append('success_action_status', '200')
          form_data.append('key', imageUri)
          form_data.append('file', image)
          let config = {
            headers: {
              'Content-Type': 'multipart/form-data',
            }
          }
          this.uploadToOss(form_data, config, imageUri)
        }
      }).catch((error) => {
        console.log(error)
      })

    },
    uploadToOss (formdata, config, imageUri) {
      var url = 'https://intellieditor-lib.oss-cn-hangzhou.aliyuncs.com/'
      axios.post(url, formdata, config, imageUri).then((res) => {
        if (res.status === 200) {
          var newHeadimgUrl = url + imageUri
          if (this.cropType === 'headImgcrop') {
            this.$root.eventHub.$emit('setCropperAfterHeadimg', newHeadimgUrl, this.headimgOrignUrl)
          } else if (this.cropType === 'atlImgCrop') {
            this.$root.eventHub.$emit('setCurrentAtlImg', newHeadimgUrl, this.headimgOrignUrl)
          }
          this.visible = false
        }

      }).catch(error => {
        console.log(error)
      })

    }




  },
  watch: {
    visible () {
      if (!this.visible) {
        $('#image').cropper('destroy')
        $('.each_cropper_button').removeClass('each_cropper_button_active')
        this.followOrignUrl = ''
        this.currentSize = 16 / 10
      }
    }
  },
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style lang='stylus' scoped>
.headimg_box
  .headimg
    position relative
    width 900px
    height 700px
    border-radius 6px
    background #fff

    .title
      clear both
      box-sizing border-box
      padding 0 14px 0 14px
      height 48px
      border-bottom 1px solid #E4E7ED

      .title_name
        span-medium-title()
        float left
        line-height 48px

      .iconfont
        float right
        font-size 22px
        line-height 48px
        cursor pointer

    .watermark
      display flex
      height calc(100% - 50px)

      .watermark_left
        box-sizing border-box
        padding-left 40px
        width 180px
        height 100%
        border-right 1px solid #E4E7ED

        .watermark_title
          height 42px
          line-height 42px

        .each_cropper_button
          margin-bottom 10px

          button
            padding 0 !important
            width 104px
            height 42px
            text-align center
            line-height 0

        .each_cropper_button_active
          button
            background #688eff
            color #fff

      .watermark_right
        flex 1
        clear both
        height 90%

        .content_title
          clear both
          box-sizing border-box
          padding-right 20px
          padding-left 20px
          width 100%
          height 42px
          line-height 42px

        .cropper_container
          box-sizing border-box
          margin-left 20px
          width 96%
          height 540px

          img
            max-width 100%

    .headimg_buttom
      position absolute
      bottom 20px
      display flex
      justify-content flex-end
      box-sizing border-box
      padding-right 20px
      width 100%
      border-radius 0 0 6px 6px

      button
        width 74px
        height 32px
        center()
        line-height 0
</style>
